import React from "react";
import Main from "./Main.tsx";

function App() {
  return (
    <div className="App">
      <Main />
    </div>
  );
}

export default App;
